{
  "enum": {
    "IxcDtccCnsV1AssetDayStatus": {
      "BLOCKED": "Blocked",
      "BREAK": "Break",
      "CURRENT": "Current",
      "RECONCILED": "Reconciled",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxcDtccCnsV1AssetDayQueryServiceAssetDayListFilterableFields": {
      "assetId": "Asset",
      "data": {
        "opening": {
          "openingFail": {
            "daysOpen": "Opening Fail Days Open",
            "quantity": "Opening Fail Quantity"
          }
        },
        "reconciledTotals": {
          "closingFail": {
            "daysOpen": "Reconciled Closing Fail Days Open",
            "quantity": "Reconciled Closing Fail Quantity"
          },
          "openingFail": {
            "daysOpen": "Reconciled Opening Fail Days Open",
            "quantity": "Reconciled Opening Fail Quantity"
          }
        },
        "security": {
          "cusip": "CUSIP"
        }
      },
      "date": "Date",
      "status": "Status"
    }
  },
  "oneOf": {
    "IxcDtccCnsV1AssetDayEventType": {
      "break": "Break",
      "cnsCorporateActionPayment": "CNS Corporate Action Payment",
      "cnsMessage": "CNS Message",
      "noActivityClose": "No Activity Close",
      "open": "Open",
      "openingFigures": "Opening Figures",
      "reconcile": "Reconcile",
      "reconciled": "Reconciled",
      "tradeTotals": "Trade Totals"
    }
  },
  "searchEnum": {
    "IxcDtccCnsV1AssetDayQueryServiceAssetDayListSearchableFields": {
      "data": {
        "security": {
          "name": "Name",
          "symbol": {
            "base": "Symbol Base"
          }
        }
      }
    }
  },
  "sortEnum": {
    "IxcDtccCnsV1AssetDayQueryServiceAssetDayListSortableFields": {
      "data": {
        "opening": {
          "openingFail": {
            "daysOpen": "Opening Fail Days Open",
            "quantity": "Opening Fail Quantity"
          }
        },
        "reconciledTotals": {
          "closingFail": {
            "daysOpen": "Reconciled Closing Fail Days Open",
            "quantity": "Reconciled Closing Fail Quantity"
          },
          "openingFail": {
            "daysOpen": "Reconciled Opening Fail Days Open",
            "quantity": "Reconciled Opening Fail Quantity"
          }
        }
      },
      "date": "Date",
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}